export default "__VITE_ASSET__490e683b__"